import {FC} from 'react'
import {useLocation} from 'react-router-dom'
import {Tab} from 'components/ui/Tab'
import styles from './LinkTab.scss'

type LinkTabProps = {
  isShowContractTab: boolean
  isSentContract: boolean
  employeeId: string
  contractRequestId?: string
}

export const LinkTab: FC<LinkTabProps> = ({isShowContractTab, isSentContract, employeeId, contractRequestId}) => {
  const {pathname} = useLocation()

  return (
    <div className={styles.tabs}>
      <Tab active={pathname === `/documents/employees/${employeeId}`} to={`/documents/employees/${employeeId}`}>
        書類一覧
      </Tab>
      {isShowContractTab && (
        <Tab
          active={pathname === `/documents/employees/${employeeId}/contracts/${contractRequestId}`}
          to={`/documents/employees/${employeeId}/contracts/${contractRequestId}`}
          disabled={!isSentContract}
        >
          電子契約一覧
        </Tab>
      )}
    </div>
  )
}
